module.exports = __webpack_public_path__ + "img/1T_510k_otc.6a90cf26.jpg";